<div class="d-flex flex-nowrap flex-row align-items-center justify-content-between fs-4">
	<span *ngIf="title" class="me-2">{{ title }}:</span>
	<div class="rounded border d-inline-flex" [attr.data-cy]="'buttonToggle-' + id" [attr.value]="value">
		<ng-content></ng-content>
	</div>
</div>
